<template>
  <div class="error-card">
    <div class="uk-width-1-1 uk-flex uk-flex-center" uk-grid>
      <div>
          <img :src="errorIcon">
      </div>
    </div>
    <h1 class="heading uk-text-center">{{errorHeading}}</h1>
    <span v-if="errorDescription.a">
      <p class="description uk-text-center uk-margin-small">{{errorDescription.a}}<br>{{errorDescription.b}}</p>
    </span>
    <p v-else class="description uk-text-center uk-margin-small">{{errorDescription}}</p>
    <div v-if="showSearch" class="uk-width-1-1 uk-margin-medium-top errorCode">
      <div class="uk-flex uk-flex-center">
        <form v-on:submit.prevent="submitSearch" class="uk-width-1-1 uk-search uk-search-default uk-align-center">
          <input class="search-box uk-search-input uk-box-shadow-medium" type="search"
                 placeholder="Search for Resources" v-model="searchText" autocomplete="off" required id="Search">
          <router-link :to="{name: 'Search', query:{searchText:dirtyText, key: new Date().getTime()}}">
          <img class="uk-search-icon-flip" :src='searchSlate'>
          </router-link>
        </form>
      </div>
    </div>
    <div class="uk-width-1-1 uk-text-center">
      <span class="code">{{errorCode}}</span>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'

  export default {
    name: 'error-card',
    props: ['errorHeading', 'errorDescription', 'errorCode', 'showSearch'],
    data() {
      return {
        dirtyText: null,
        errorIcon: iconUtil.resolve(misc.ERROR_INFO_ICON),
        searchSlate: iconUtil.resolve(misc.SEARCH_ICON)
      }
    },
    computed: {
      ...mapGetters(['searchTerm']),
      searchText: {
        get: function () {
          return this.searchTerm
        },
        set: function (newVal) {
          this.setSearchCriteria({searchText: newVal})
          this.dirtyText = newVal
        }
      }
    },
    methods: {
      ...mapActions(['performSearch', 'setSearchCriteria']),
      removeSearchText() {
        this.searchText = null
      },
      submitSearch() {
        this.performSearch({searchText: this.dirtyText})
        this.dirtyText = null
      }
    },
    watch: {
      searchTerm(value) {
        this.searchText = value
      }
    },
    mounted() {
      this.searchText = this.searchTerm
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/breakpoints.scss';
  @import '../../styles/colours.scss';
  form{
    position:relative
  }
  .errorCode {
    margin-bottom: 80px;
  }

  .uk-search-icon-flip {
    z-index: 2;
    position: absolute;
    margin-top: 15px;
    width: 52px;
    height: 53px;
  }

  .error-card {
    margin: 3.5% 15% 3.5% 15%;
    width: 82.5%;
  }

  .uk-heading-primary {
    color: rgba(0, 1, 2, 0.7);
  }

  .heading {
    font-size: 28.7px;
    line-height: normal;
    line-height: 1.2;
    font-weight: bold;
    color: rgba(0, 1, 2, 0.7);
  }

  .description {
    font-size: 23.1px;
    line-height: 1.0;
    font-size: 16px;
    color: rgba(0, 1, 2, 0.7);
  }

  .uk-search-default .search-box  {
    height: 48px;
    font-size: 14px;
    opacity: 0.75;
    position: absolute;
    background-color: white;
    padding-left: 15px;
    width: 490px;
    margin-top: -5px;
  }

  .uk-search-default{
    height: 48px;
    border-radius: 2px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    padding: 0;
    .uk-search-input{
      border: 0px solid #e5e5e5;
    }
  }
  input::placeholder{
    color: $slate !important;
    padding-right: 12px;
  }
  .code {
    font-size: 16.8px;
    line-height: 32.9px;
    color: rgba(0, 1, 2, 0.4);
  }

  @media screen and (max-width: $breakpoint-small) {
    .uk-heading-primary {
      font-size: 2.1em;
      line-height: 1.3;
    }
    .heading {
      font-size: 20px;
      line-height: 28px;
    }
    .description {
      line-height: 22px;
      font-size: 16px;
    }
    .code {
      font-size: 14px;
      line-height: 47px;
    }
  }

  @media screen and (min-width: $breakpoint-medium) {
    .heading {
      font-size: 38px;
    }
    .description {
      font-size: 28px;
    }
    .uk-search-default .search-box {
      height: 67px;
      font-size: 20px;
      padding-left: 15px;
      width: 490px;
      margin-top: 0px;
    }
    .uk-search-default{
      height: 67px;
    }
    .code {
      font-size: 24px;
    }
  }

  @media screen and (min-width: $breakpoint-xlarge) {
    .heading {
      font-size: 41px;
    }
    .description {
      font-size: 33px;
    }
    .uk-search-default .search-box {
      height: 86px;
      font-size: 24px;
      width: 538px;
      padding-left: 25px;
      margin-top: 0px;
    }
    .uk-search-default{
      height: 86px;
      width: 597px;
    }
    .code {
      font-size: 24px;
    }
  }

</style>
